import React from 'react'
import clsx from 'clsx'
import { useIntl } from 'react-intl'
import RefreshButton from '../RefreshButton'
import Heading from '../Heading'
import { Button } from '../Button'
import { useMediaLibrary } from './MediaLibraryContext'
import ButtonGroup from '../Button/ButtonGroup'
import LoadingButton from '../Button/LoadingButton'

const MediaLibraryHeader = () => {
	const { formatMessage } = useIntl()

	const {
		title,
		loading,
		bulkSelect,
		bulkSelectActions,
		selectedFiles,
		handleBulkSelectClick,
		handleOpenUploadModal,
		onRefreshClick,
	} = useMediaLibrary()

	return (
		<header
			className={clsx(
				'flex flex-wrap items-center justify-between mb-2',
				title ? 'justify-between' : 'justify-end'
			)}
		>
			<div className="flex flex-row items-center">
				{title && (
					<Heading
						button={
							typeof onRefreshClick === 'function' ? (
								<RefreshButton
									onClick={onRefreshClick}
									disabled={loading}
								/>
							) : null
						}
					>
						{title}
					</Heading>
				)}
				{handleBulkSelectClick && (
					<Button
						text={
							bulkSelect
								? formatMessage({ id: 'remove_record.cancel' })
								: formatMessage({ id: 'global.bulk_select' })
						}
						onClick={handleBulkSelectClick}
						variant="outlined"
					/>
				)}
			</div>
			{bulkSelectActions && bulkSelect && (
				<ButtonGroup
					overflowLimit={2}
					items={bulkSelectActions.map((action, index) => (
						<LoadingButton
							key={action.text}
							text={action.text}
							onClick={() => action.onClick(selectedFiles)}
							disabled={!selectedFiles.length}
							loading={loading}
							variant={index < 2 ? action.variant : 'text'}
							fullWidth={false}
						/>
					))}
				/>
			)}
			{handleOpenUploadModal && !bulkSelect && (
				<LoadingButton
					text={formatMessage({ id: 'global.upload' })}
					onClick={handleOpenUploadModal}
					loading={loading}
					fullWidth={false}
				/>
			)}
		</header>
	)
}

export default MediaLibraryHeader
